import { CANONICAL_LINK_ID, MODULE_NAME } from './constant';
import { isActiveById, getSettingsById } from '../../utils';

export const isActive = () => isActiveById(MODULE_NAME);
export const getSettings = () => getSettingsById(MODULE_NAME);

// Conditionally created canonical link if it doesn't exist.
// Always sets the href.
export const linkSetHref = ({ pathname, origin }) => {
  let link = document.getElementById(CANONICAL_LINK_ID);

  if (!link) {
    link = document.createElement('link');
    link.id = CANONICAL_LINK_ID;
    link.rel = 'canonical';
    document.head.appendChild(link);
  }

  link.href = `${origin}${pathname}`;
};

export const linkRemove = () => {
  const link = document.getElementById(CANONICAL_LINK_ID);
  if (link) link.remove();
};
